import type { OnboardingV3GoalType } from "./onboardingV3Types";

const GOAL_ID_TO_TYPE: Record<string, OnboardingV3GoalType> = {
  million: "million",
  home: "home",
  runway: "emergency",
  "idle-cash": "idlecash",
  retirement: "retirement",
  "debt-free": "debt",
};

export const mapGoalIdToGoalType = (goalId: string): OnboardingV3GoalType => {
  const mapped = GOAL_ID_TO_TYPE[goalId.trim()];
  if (!mapped) {
    return "million";
  }
  return mapped;
};
